export const brands = {
  get_all: "products/brand/",
  create: "products/brand/",
  get_by_id: (id: number) => `products/brand/get-by/?id=${id}`,
  delete: (id: number) => `products/brand/?id=${id}`,
  edit: (id: number) => `products/brand/?id=${id}`,
};
